<template>
    <van-popup v-model:show="show" position="bottom" :style="{
        minWidth: '100%',
        minHeight: '100%',
    }">
        <div class="popupContainer">
            <HeadCard />
            <div class="banner">
                <img src="@/assets/profile/banner.png" alt="" :class="{ 'pop-animate': dataSet?.isPopping }"
                    @click="clickBanner()">
            </div>
            <VipCard />
            <MenuCard />

            <div v-for="(item, index) in dataSet?.componentList" :key="index">
                <DownloadPanel v-if="isComponentVisible(item, 'AppDownload')" :itemData="item" />
                <MediaSection v-if="isComponentVisible(item, 'shareMedia')" :itemData="item" />
                <FooterText v-if="isComponentVisible(item, 'footerText')" :itemData="item" />
            </div>

        </div>
    </van-popup>
</template>

<script setup lang="ts">
import { ref, defineExpose, defineEmits, defineProps, computed } from 'vue'
import HeadCard from './components/headCard.vue'
import VipCard from './components/vipCard.vue'
import MenuCard from './components/menuCard.vue'
import DownloadPanel from '../home/components/downloadPanel.vue'
import MediaSection from '../home/components/mediaSection.vue'
import FooterText from '../home/components/footerText.vue'
import { ProfilePoupData } from '@/view/profile/supportScript'

const props = defineProps<{
    dataSet: ProfilePoupData
}>()

const show = computed({
    get: () => props.dataSet.show,
    set: (val) => emits('update:show', val)
})
const emits = defineEmits(['close', 'clickBanner', 'update:show'])


const close = () => {
    emits('close')
}
const clickBanner = () => {
    emits('clickBanner')
}

const isComponentVisible = (item: any, menuId: string) => {
    return (
        item.component_id === props.dataSet.componentIdsInOrderConfig[menuId] && item.display
    );
};
defineExpose({
    open,
    close
})

</script>
<style scoped>

.van-popup {
    background-image: url('@/assets/main_bg.png');
    background-size: cover;
    background-repeat: repeat;
    -ms-overflow-style: none;
    scrollbar-width: none;
    overflow-y: auto;
    width: 100%;
    min-height: 100vh;
    padding-bottom: 100px;
}
.van-popup::-webkit-scrollbar {
    display: none;
}

.banner {
    padding: 5px 15px;
}

.banner img {
    width: 100%;
    border-radius: 10px;
}

.pop-animate {
    animation: pop-scale 0.3s ease;
}

@keyframes pop-scale {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(0.9);
    }

    100% {
        transform: scale(1);
    }
}
</style>